import React, { useEffect, useMemo, useState } from 'react';
import { agriAlertGetPlantingData } from '@/util/Request/agrialert';
import { IGetPlantingReqModel } from '@/util/Request/agrialert/requestType';
import {
    IAgriAlertTranslateResModel,
    IGetPlantingdDataResModel,
} from '@/util/Request/agrialert/responseType';
import moment from 'moment';
import cuid from '@paralleldrive/cuid2';
// self
import { getWeekTranslate } from '../../initData';
import IF from '@/components/IF';
import './index.less';
import { lowerCaseFirstLetter } from '@/util/commonFunction';
const frCropTypes = ['PW_Corn_FR', 'PW_Sunflower_FR'];

interface IProp {
  showPlanting: boolean;
  allPlantingReq: IGetPlantingReqModel[];
  translateValue: IAgriAlertTranslateResModel;
  languageCode: string;
}

const TemplatePlanting = (prop: IProp) => {
    const { showPlanting, allPlantingReq, languageCode, translateValue } = prop;

    const finalFormat = languageCode === 'fr' ? 'DD/MM' : 'MM/DD';

    // For houlry
    const [currentPlantingData, setCurrentPlantingData] = useState<IGetPlantingdDataResModel[][]>([]);
    const [currentPlantingDataForForecast, setCurrentPlantingDataForForecast] = useState<IGetPlantingdDataResModel[]>([]);
    const [currentPlantingDataForHistorical, setCurrentPlantingDataForHistorical] = useState<IGetPlantingdDataResModel[]>([]);
    const [currentPlantingDataForMixed, setCurrentPlantingDataForMixed] = useState<IGetPlantingdDataResModel[]>([]);

    // For daily: only France have daily value
    const [currentPlantingForFranceData, setCurrentPlantingForFranceData] = useState<IGetPlantingdDataResModel[][]>([]);
    const [currentPlantingForFranceDataForForecast, setCurrentPlantingForFranceDataForForecast] = useState<IGetPlantingdDataResModel[]>([]);
    const [currentPlantingForFranceDataForHistorical, setCurrentPlantingForFranceDataForHistorical] = useState<IGetPlantingdDataResModel[]>([]);
    const [currentPlantingForFranceDataForMixed, setCurrentPlantingForFranceDataForMixed] = useState<IGetPlantingdDataResModel[]>([]);
    const [maxMixedDate, setMaxMixedDate] = useState<string[]>([]);
    const [maxForecastDate, setMaxForecastDate] = useState<string[]>([]);

    const [currentMixedToday,setCurrentMixedToday] = useState<string>(null);

    const [repeatRequest, setRepeatRequest] = useState<string[]>([]);
    const [repeatRequestForFR, setRepeatRequestForFr] = useState<string[]>([]);

    const mergedPlantingReq = useMemo(() => {
        const repeatEntries: string[] = []; // 临时存储重复项

        const result = allPlantingReq.reduce((acc, current) => {
            if (frCropTypes.includes(current.cropType)) {
            // 如果当前 cropType 在排除列表中，则跳过
                return acc;
            }
            const existingGroup = acc.find((item) => item.groupId === current.groupId);

            if (existingGroup) {
                const riskList = existingGroup.cropType.split(';');
                if (riskList.includes(current.cropType)) {
                // 收集重复条目
                    const duplicateEntry = `${current.cropType}#${current.startDate}#${current.endDate}`;
                    repeatEntries.push(duplicateEntry);
                } else {
                // 拼接新的 diseaseRisk
                    existingGroup.cropType += `;${current.cropType}`;
                }
            } else {
            // 添加新项
                acc.push({ ...current });
            }

            return acc;
        }, [] as IGetPlantingReqModel[]);

        // 统一更新 repeatRequest（仅收集到新重复项时才更新）
        setRepeatRequest(repeatEntries);

        return result;
    }, [allPlantingReq]); // 仅在这两个依赖变化时重新执行

    // const mergedPlantingReq = allPlantingReq.reduce((acc, current) => {
    //     if (frCropTypes.includes(current.cropType)) {
    //         // 如果当前 cropType 在排除列表中，则跳过
    //         return acc;
    //     }
    //     const existingGroup = acc.find((item) => item.groupId === current.groupId);

    //     if (existingGroup) {
    //         // 如果已经存在相同的 groupId，则拼接 diseaseRisk
    //         existingGroup.cropType += `;${current.cropType}`;
    //     } else {
    //         // 如果不存在相同的 groupId，则添加新的项
    //         acc.push({ ...current });
    //     }

    //     return acc;
    // }, [] as IGetPlantingReqModel[]);
    const mergedPlantingReqForFrance = useMemo(() => {
        const repeatEntries: string[] = []; // 临时存储重复项

        const result = allPlantingReq.reduce((acc, current) => {
            if (!frCropTypes.includes(current.cropType)) {
            // 如果当前 cropType 不在包含列表中，则跳过
                return acc;
            }
            const existingGroup = acc.find((item) => item.groupId === current.groupId);

            if (existingGroup) {
                const riskList = existingGroup.cropType.split(';');
                if (riskList.includes(current.cropType)) {
                // 收集重复条目
                    const duplicateEntry = `${current.cropType}#${current.startDate}#${current.endDate}`;
                    repeatEntries.push(duplicateEntry);
                } else {
                // 拼接新的 diseaseRisk
                    existingGroup.cropType += `;${current.cropType}`;
                }
            } else {
            // 添加新项
                acc.push({ ...current });
            }

            return acc;
        }, [] as IGetPlantingReqModel[]);

        // 统一更新 repeatRequest（仅收集到新重复项时才更新）
        setRepeatRequestForFr(repeatEntries);

        return result;
    }, [allPlantingReq]); // 仅在这两个依赖变化时重新执行

    // const mergedPlantingReqForFrance = allPlantingReq.reduce((acc, current) => {
    //     if (!frCropTypes.includes(current.cropType)) {
    //         // 如果当前 cropType 不在包含列表中，则跳过
    //         return acc;
    //     }
    //     const existingGroup = acc.find((item) => item.groupId === current.groupId);

    //     if (existingGroup) {
    //         // 如果已经存在相同的 groupId，则拼接 diseaseRisk
    //         existingGroup.cropType += `;${current.cropType}`;
    //     } else {
    //         // 如果不存在相同的 groupId，则添加新的项
    //         acc.push({ ...current });
    //     }

    //     return acc;
    // }, [] as IGetPlantingReqModel[]);


    const initFunc = () => {
        const tmpMergedPlantingReq = mergedPlantingReq;
        const tmpMergedPlantingReqForFrance = mergedPlantingReqForFrance;
        if (tmpMergedPlantingReq?.length >= 1) {
            getPlantintListDataFunc(tmpMergedPlantingReq, false);
        }
        if (tmpMergedPlantingReqForFrance?.length >= 1) {
            getPlantintListDataFunc(tmpMergedPlantingReqForFrance, true);
        }
    };

    // get spray windows data
    const getPlantintListDataFunc = async (
        allReq: IGetPlantingReqModel[],
        isFrance: boolean
    ) => {
        try {
            // 创建一个数组来存储所有的 promise
            const promises = allReq?.map(async (item) => {
                return getPlantingDataFuc(item, isFrance);
            });

            // 使用 Promise.all 等待所有的 promise 完成
            const results = await Promise.all(promises);

            // 处理结果
            if (isFrance) {
                console.log('All planting fr data:', results);
                setCurrentPlantingForFranceData(results);
            } else {
                console.log('All planting no fr data:', results);
                setCurrentPlantingData(results);
            }

            return results; // 返回所有结果
        } catch (error) {
            console.error('Failed to get spray list data, error is: ', error);
            return null;
        }
    };

    const getPlantingDataFuc = async (
        requestModel: IGetPlantingReqModel,
        isFrance: boolean
    ) => {
        try {
            const res = await agriAlertGetPlantingData(requestModel);
            const format = languageCode === 'fr' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
            if (res?.data?.length >= 1) {
                res?.data?.forEach((item, itemIndex) => {
                    // translate the week name
                    item?.date?.forEach((dateItem, dateIndex) => {
                        const dayOfWeek = moment(dateItem, format)?.day();
                        console.log('lanxue color', dayOfWeek);
                        res.data[itemIndex].date[dateIndex] =
              dateItem + ' ' + getWeekTranslate(translateValue, dayOfWeek);
                    });
                    // for crop name translate
                    const tmpCropCode = lowerCaseFirstLetter(item?.cropCode);
                    res.data[itemIndex].cropName = translateValue?.[tmpCropCode];
                    // for background color
                    if (!item.backColors) {
                        item.backColors = [];
                    }
                    item?.recommendationValus?.forEach((recoItem, recoIndex) => {
                        const tmpColor = [];
                        recoItem?.map((innerItem) => {
                            if (isFrance) {
                                if (innerItem === '0') {
                                    tmpColor.push('rgb(238, 26, 26)');
                                } else if (innerItem === '1') {
                                    tmpColor.push('rgb(225, 122, 0)');
                                } else if (innerItem === '2') {
                                    tmpColor.push('rgb(65, 195, 4)');
                                } else {
                                    tmpColor.push('rgb(238, 26, 26)');
                                }
                            } else {
                                if (innerItem === '0') {
                                    tmpColor.push('rgb(238, 26, 26)');
                                } else if (innerItem === '1') {
                                    tmpColor.push('rgb(65, 195, 4)');
                                } else {
                                    tmpColor.push('rgb(238, 26, 26)');
                                }
                            }
                        });
                        res.data[itemIndex].backColors.push(tmpColor);
                    });
                });
            }
            return res?.data;
        } catch (error) {
            return null;
            console.log('get spray windows data failed, error is ', error);
        }
    };

    const classifyDataByFirstDate = (data: IGetPlantingdDataResModel[][],isFrance?: boolean) => {
        const currentDate = moment().startOf('day'); // 获取当前日期（去掉时间部分）
        const historicalArray:IGetPlantingdDataResModel[] = []; // 存储历史数据
        const futureArray:IGetPlantingdDataResModel[] = []; // 存储未来数据

        const mixedData = [];
        // filter for mixed value
        const tmpAllPlantingReq = isFrance ? allPlantingReq.filter(x => frCropTypes.includes(x.cropType)) : allPlantingReq.filter(x => !(frCropTypes.includes(x.cropType)));
        const uniqueGroupIdForMixed = Array.from(new Set(tmpAllPlantingReq?.map(item => item.groupIdForMixed)
            ?.filter((value): value is string => value !== undefined)));

        // for forecast and historical group
        data.forEach((group) => {
            group.forEach((item) => {
                const firstDateStr = item?.originDate?.[0]?.split(' ')[0]; // 提取第一个日期部分
                if (!firstDateStr) {
                    console.error('Invalid date array:', item);
                    return;
                }

                const firstDate = moment(firstDateStr, 'YYYY-MM-DD', true); // 使用严格模式解析日期
                if (!firstDate.isValid()) {
                    console.error('Invalid first date:', firstDateStr, 'in item:', item);
                    return;
                }

                // 判断第一个日期是否小于当前日期
                if (firstDate.isBefore(currentDate, 'day')) {
                    historicalArray.push(item); // 归类为历史数据
                } else {
                    futureArray.push(item); // 归类为未来数据
                }
            });
        });

        const tmpRepeatRequest = isFrance ? repeatRequestForFR : repeatRequest;
        tmpRepeatRequest.forEach((item) => {
            const [modelId, startDate,endDate] = item.split('#');
            const tmpFutureItem = futureArray.find((futureItem) =>
                futureItem.cropCode === modelId &&
                futureItem.originDate?.[0] === startDate &&
                futureItem.originDate?.[futureItem.originDate?.length - 1] === endDate);
            const tmpHistoricalItem = historicalArray.find((historicalItem) =>
                historicalItem.cropCode === modelId &&
                historicalItem.originDate?.[0] === startDate &&
                historicalItem.originDate?.[historicalItem.originDate?.length - 1] === endDate);
            if(tmpFutureItem){
                futureArray.push(tmpFutureItem);
            }
            if(tmpHistoricalItem){
                historicalArray.push(tmpHistoricalItem);
            }
        });

        const mixedFutureIndex = [];
        const mixedHistoricalIndex = [];

        let maxForecastDate = [];
        let maxHistoricalDate = [];
        uniqueGroupIdForMixed?.forEach((item) => {
            // const groutKeyData = item?.split('-');
            const [historicalDaysStr, forecastDaysStr, modelId] = item.split('-');
            if (!historicalDaysStr || !forecastDaysStr || !modelId) {
                console.warn(`Invalid groupId format: ${item}`);
                return;
            }
            let tmpFutureItem:IGetPlantingdDataResModel = null;
            let tmpHistoricalItem:IGetPlantingdDataResModel = null;
            // for future
            for (let itemIndex = 0; futureArray && itemIndex < futureArray.length; itemIndex++) {
                const item = futureArray[itemIndex];
                if (item.cropCode === modelId &&
                    item?.date?.length === Number(forecastDaysStr) &&
                    !(mixedFutureIndex?.includes(itemIndex))
                ) {
                    tmpFutureItem = item;
                    mixedFutureIndex.push(itemIndex);
                    break; // 找到后立即退出循环
                }
            }
            // futureArray?.forEach((item, itemIndex) => {
            //     if (item?.cropCode === modelId && item?.date?.length === Number(forecastDaysStr)) {
            //         tmpFutureItem = item;
            //         mixedFutureIndex.push(itemIndex);
            //         return;
            //     }
            // });
            // for historical
            for (let itemIndex = 0; historicalArray && itemIndex < historicalArray.length; itemIndex++) {
                const item = historicalArray[itemIndex];
                if (item.cropCode === modelId &&
                    item?.date?.length === Number(historicalDaysStr) &&
                    !(mixedHistoricalIndex?.includes(itemIndex))
                ) {
                    tmpHistoricalItem = item;
                    mixedHistoricalIndex.push(itemIndex);
                    break; // 找到后立即退出循环
                }
            }
            // historicalArray?.forEach((item, itemIndex) => {
            //     if (item.cropCode === modelId && item?.date?.length === Number(historicalDaysStr)) {
            //         tmpHistoricalItem = item;
            //         mixedHistoricalIndex.push(itemIndex);
            //         return;
            //     }
            // });
            // set for max date
            if(tmpFutureItem?.date?.length > maxForecastDate?.length) {
                maxForecastDate = [...tmpFutureItem.date];
            }
            if(tmpHistoricalItem?.date?.length > maxHistoricalDate?.length) {
                maxHistoricalDate = [...tmpHistoricalItem.date];
            }
            const tmpMixedItem: IGetPlantingdDataResModel = {
                backColors: [...tmpHistoricalItem.backColors,...tmpFutureItem.backColors],
                date: [...tmpHistoricalItem.date,...tmpFutureItem.date],
                cropCode: tmpHistoricalItem.cropCode,
                cropName: tmpHistoricalItem.cropName,
                values: [...tmpHistoricalItem.values,...tmpFutureItem.values],
                weeks: [...tmpHistoricalItem.weeks,...tmpFutureItem.weeks],
            };
            mixedData.push(tmpMixedItem);
            if(tmpFutureItem?.date?.length >= 1 && currentMixedToday === null) {
                setCurrentMixedToday(tmpFutureItem?.date?.[0]);
            }
        });



        if(isFrance){
            setCurrentPlantingForFranceDataForMixed(mixedData);
            setCurrentPlantingForFranceDataForForecast(futureArray?.filter((_, index) => !mixedFutureIndex?.includes(index)) || []);
            setCurrentPlantingForFranceDataForHistorical(historicalArray?.filter((_, index) => !mixedHistoricalIndex?.includes(index)) || []);
            setMaxMixedDate([...maxHistoricalDate, ...maxForecastDate]);
        }
        else{
            setCurrentPlantingDataForMixed(mixedData);
            setCurrentPlantingDataForForecast(futureArray?.filter((_, index) => !mixedFutureIndex?.includes(index)) || []);
            setCurrentPlantingDataForHistorical(historicalArray?.filter((_, index) => !mixedHistoricalIndex?.includes(index)) || []);
        }

    };

    useEffect(() => {
        if (showPlanting && translateValue) {
            initFunc();
        }
    }, [showPlanting, translateValue]);

    useEffect(()=>{
        if (currentPlantingData?.length >= 1) {
            classifyDataByFirstDate(currentPlantingData);
        }
        if (currentPlantingForFranceData?.length >= 1) {
            classifyDataByFirstDate(currentPlantingForFranceData,true);
        }
    },[currentPlantingData,currentPlantingForFranceData]);

    useEffect(() => {
        const maxDateItem = currentPlantingForFranceDataForForecast.reduce((prev, current) => {
            return (current.date?.length || 0) > (prev.date?.length || 0) ? current : prev;
        }, {} as IGetPlantingdDataResModel);

        const maxDates = maxDateItem.date || [];
        setMaxForecastDate(maxDates);
    }, [currentPlantingForFranceDataForForecast]);


    console.log('lanxue final plantingData currentPlantingData: ', currentPlantingData);
    console.log('lanxue final plantingData currentPlantingDataForForecast: ', currentPlantingDataForForecast);
    console.log('lanxue final plantingData currentPlantingDataForHistorical: ', currentPlantingDataForHistorical);
    console.log('lanxue final plantingData currentPlantingDataForMixed: ', currentPlantingDataForMixed);
    return (
        <div>
            {/* Forecast and Historical */}
            <IF show={currentPlantingDataForForecast?.length >= 1 || currentPlantingDataForHistorical?.length >= 1 ||
                currentPlantingForFranceDataForForecast?.length >= 1 || currentPlantingForFranceDataForHistorical?.length >= 1
            }>
                <div className="planting-all-container" style={{overflow:'auto'}}>
                    <div className="historical-chart-title common-title">
                        {translateValue?.planting_recommendation || 'Planting Recommendation'}
                    </div>
                    {/* hourly */}
                    <IF show={currentPlantingDataForForecast?.length >= 1 || currentPlantingDataForHistorical?.length >= 1}>
                        <div className="">
                            <div className="forecast-table content-basic">
                                {/* different item mean different time */}
                                {[...currentPlantingDataForForecast,...currentPlantingDataForHistorical]?.map((trueItem, index) => {
                                    return (
                                        <>
                                            <div
                                                // key={`spray-container-${index}-${item?.id}`}
                                                key={cuid.createId()}
                                                className="spray-list-container"
                                            >
                                                <div
                                                    className="spray-item-name"
                                                    style={{ margin: '5px 0px' }}
                                                >
                                                    {trueItem?.cropName}
                                                </div>
                                                <table className="spray-table-container">
                                                    <thead>
                                                        <tr>
                                                            <td className="thead-tr-var basic-first-td">
                                                                {translateValue?.hours_of_the_day ||
                                    'Hours of the day'}
                                                            </td>
                                                            {Array.from({ length: 24 }, (_, i) =>
                                                                i < 10 ? `0${i}` : `${i}`
                                                            ).map((item) => {
                                                                return (
                                                                    <>
                                                                        <td className="thead-tr-day basic-td">
                                                                            {item}
                                                                        </td>
                                                                    </>
                                                                );
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {trueItem?.values?.map(
                                                            (valueItem, valueIndex) => {
                                                                return (
                                                                    <>
                                                                        <tr key={cuid.createId()}>
                                                                            <td className="tdoby-tr-var basic-first-td">
                                                                                {`${trueItem?.date?.[valueIndex]}`}
                                                                            </td>
                                                                            {valueItem?.map(
                                                                                (innerItem, innerIndex) => {
                                                                                    return (
                                                                                        <td
                                                                                            key={cuid.createId()}
                                                                                            className="tdoby-tr-day basic-td"
                                                                                            style={{
                                                                                                backgroundColor: `${trueItem?.backColors?.[valueIndex]?.[innerIndex]}`,
                                                                                            }}
                                                                                        >
                                                                                            {innerItem || ''}
                                                                                        </td>
                                                                                    );
                                                                                }
                                                                            )}
                                                                        </tr>
                                                                    </>
                                                                );
                                                            }
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    );
                                })}
                            </div>

                            {/* @* Color Legend *@ */}
                            <div className="new-color-legend" >
                                <table className="color-legend-table">
                                    <thead>
                                        <tr className="color-first-tr">
                                            <td colSpan={6}>
                                                {translateValue?.color_legend || 'Color Legend'}
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div
                                                    className="square"
                                                    style={{ backgroundColor: 'rgb(65, 195, 4)' }}
                                                ></div>
                                            </td>
                                            <td>
                                                <span>{translateValue?.recommended || 'Recommended'}</span>
                                            </td>
                                            <td>
                                                <div
                                                    className="square"
                                                    style={{ backgroundColor: 'rgb(238, 26, 26)' }}
                                                ></div>
                                            </td>
                                            <td>
                                                <span>{translateValue?.not_advisable || 'Not Advisable'}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* @* Restrictions Legend *@ */}
                            <div className="restrictions-legend">
                                <table className="restrictions-legend-table">
                                    <thead>
                                        <tr className="restrictions-first-tr">
                                            <td colSpan={6}>
                                                {translateValue?.planting_legend || 'Planting Legend'}
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>A</td>
                                            <td>
                                                {translateValue?.resLegTooLoSoilTemp || 'ResLegTooLoSoilTemp'}
                                            </td>
                                            <td>T</td>
                                            <td>
                                                {translateValue?.resLegTooLoTemp || 'ResLegTooLoTemp'}
                                            </td>
                                            <td>R</td>
                                            <td>
                                                {translateValue?.resLegPrecipitation || 'ResLegPrecipitation'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>S</td>
                                            <td>{translateValue?.resRainExpected || 'ResRainExpected'}</td>
                                            <td>W</td>
                                            <td>{translateValue?.resLegSoilTooWet || 'ResLegSoilTooWet'}</td>
                                            <td>X</td>
                                            <td>{translateValue?.multiple || 'Multiple'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </IF>

                    {/* daily */}
                    {/* For Daily Forecast */}
                    <IF show={currentPlantingForFranceDataForForecast?.length >= 1}>
                        <div

                        >
                            <table
                                // key={`table-${index}-${tableIndex}`}
                                className="daily-table-container"
                                style={{marginBottom: '15px'}}
                            >
                                <thead>
                                    <tr>
                                        <td></td>
                                        {maxForecastDate.map((day, dayIndex) => (
                                            <td
                                                key={`day-${dayIndex}`}
                                                style={{
                                                    width: `${((822 - 130) / (maxForecastDate?.length || 1))}px`,
                                                    padding: '3px 0px',
                                                }}
                                            >
                                                {day}
                                            </td>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        currentPlantingForFranceDataForForecast?.flat()?.map((item, index) => {
                                            return (
                                                <tr
                                                    key={`item-${index}`}
                                                >
                                                    <td
                                                        style={{
                                                            width: '130px',
                                                        }}
                                                    >
                                                        {item?.cropName}
                                                    </td>
                                                    {/* render detail value */}
                                                    {maxForecastDate.map((day, dayIndex) => {
                                                        const valueIndex = item.date?.findIndex((dateItem) => dateItem === day);
                                                        const color = valueIndex !== -1 ? item?.backColors?.[valueIndex] : 'grey';
                                                        const value = valueIndex !== -1 ? item?.values?.[valueIndex] : '';
                                                        return(
                                                            <td
                                                                key={`day-${dayIndex}`}
                                                                style={{
                                                                    width: `${((822 - 130) / (maxForecastDate?.length || 1))}px`,
                                                                    height: '30px',
                                                                    backgroundColor: `${color}`,
                                                                    // color: `${color}`,
                                                                    boxSizing: 'border-box',
                                                                    padding: '3px 0px',
                                                                }}
                                                            >
                                                                {value || ''}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </table>

                            {/* @* Color Legend *@ */}
                            <div className="new-color-legend">
                                <table className="color-legend-table">
                                    <thead>
                                        <tr className="color-first-tr">
                                            <td colSpan={6}>
                                                {translateValue?.color_legend || 'Color Legend'}
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="square" style={{ backgroundColor: 'rgb(65, 195, 4)' }}></div>
                                            </td>
                                            <td>
                                                <span>{translateValue?.recommended || 'Recommended'}</span>
                                            </td>
                                            <td>
                                                <div className="square" style={{ backgroundColor: 'rgb(225, 122, 0)' }}></div>
                                            </td>
                                            <td>
                                                <span>{translateValue?.limited || 'Limited'}</span>
                                            </td>
                                            <td>
                                                <div className="square" style={{ backgroundColor: 'rgb(238, 26, 26)' }}></div>
                                            </td>
                                            <td>
                                                <span>
                                                    {translateValue?.not_advisable || 'Not Advisable'}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {/* @* Restrictions Legend *@ */}
                            <div className="restrictions-legend">
                                <table className="restrictions-legend-table">
                                    <thead>
                                        <tr className="restrictions-first-tr">
                                            <td colSpan={6}>
                                                {translateValue?.planting_legend || 'Planting Legend'}
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>A</td>
                                            <td>
                                                {translateValue?.resLegTooLoSoilTemp ||'ResLegTooLoSoilTemp'}
                                            </td>
                                            <td>P</td>
                                            <td>
                                                {translateValue?.resPastPrecipitation ||'ResPastPrecipitation'}
                                            </td>
                                            <td>p</td>
                                            <td>
                                                {translateValue?.resPrecipitationExpected || 'ResPrecipitationExpected'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>X</td>
                                            <td>{translateValue?.multiple || 'Multiple'}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </IF>
                    {/* For Daily Historical */}
                    <IF show={currentPlantingForFranceDataForHistorical?.length >= 1}>
                        <div className="">
                            <div className="forecast-table content-basic chart-or-table-top">
                                <div key={cuid.createId()} className="spray-list-container">
                                    {currentPlantingForFranceDataForHistorical?.flat()?.map((item, index) => {
                                        // 计算需要多少个表格，每个表格最多7个数据点
                                        const tableCount = Math.ceil(item.values.length / 7);
                                        console.log('lanxue ddd item', item);

                                        // 创建一个辅助函数用于将数组分块
                                        const chunkArray = (array, size) =>
                                            Array.from(
                                                { length: Math.ceil(array.length / size) },
                                                (v, i) => array.slice(i * size, i * size + size)
                                            );

                                        // 分割日期和值数组为多个长度为7的小数组
                                        const dateChunks = chunkArray(item.date, 7);
                                        const valueChunks = chunkArray(item.values, 7);
                                        const colorChunks = chunkArray(item.backColors, 7);

                                        // 提取计算td宽度的逻辑为一个函数，提高代码复用性和可读性
                                        const calculateTdWidth = () => {
                                            if (dateChunks.length === 1) {
                                                return 822 / (dateChunks[0].length || 1); // 防止除以0，这里做个兜底处理
                                            }
                                            return 822 / 7;
                                        };

                                        const tmpWidth = calculateTdWidth();
                                        console.log('lanxue ddd dateChunks', dateChunks);
                                        console.log('lanxue ddd valueChunks', valueChunks);

                                        return (
                                            <>
                                                <div
                                                    className="spray-item-name "
                                                    style={{ marginTop: '10px', marginBottom: '5px' }}
                                                >
                                                    {item.cropName}
                                                </div>
                                                {/* 根据计算出的表格数量渲染相应数量的表格 */}
                                                {dateChunks.map((dateChunk, tableIndex) => (
                                                    <table
                                                        key={`table-${index}-${tableIndex}`}
                                                        className="daily-table-container"
                                                    >
                                                        <thead>
                                                            <tr>
                                                                {dateChunk.map((day, dayIndex) => (
                                                                    <td
                                                                        key={`day-${index}-${tableIndex}-${dayIndex}`}
                                                                        style={{ width: `${tmpWidth}px` }}
                                                                    >
                                                                        {day}
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                {valueChunks[tableIndex]?.map(
                                                                    (value, valueIndex) => (
                                                                        <td
                                                                            key={`value-${index}-${tableIndex}-${valueIndex}`}
                                                                            style={{
                                                                                width: `${tmpWidth}px`,
                                                                                height: '30px',
                                                                                backgroundColor: `${colorChunks?.[tableIndex]?.[valueIndex]}`,
                                                                            }}
                                                                        >
                                                                            {value || ''}
                                                                        </td>
                                                                    )
                                                                )}
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                ))}
                                            </>
                                        );
                                    })}

                                </div>
                            </div>

                            {/* @* Color Legend *@ */}
                            <div className="new-color-legend">
                                <table className="color-legend-table">
                                    <thead>
                                        <tr className="color-first-tr">
                                            <td colSpan={6}>
                                                {translateValue?.color_legend || 'Color Legend'}
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="square" style={{ backgroundColor: 'rgb(65, 195, 4)' }}></div>
                                            </td>
                                            <td>
                                                <span>{translateValue?.recommended || 'Recommended'}</span>
                                            </td>
                                            <td>
                                                <div className="square" style={{ backgroundColor: 'rgb(225, 122, 0)' }}></div>
                                            </td>
                                            <td>
                                                <span>{translateValue?.limited || 'Limited'}</span>
                                            </td>
                                            <td>
                                                <div className="square" style={{ backgroundColor: 'rgb(238, 26, 26)' }}></div>
                                            </td>
                                            <td>
                                                <span>
                                                    {translateValue?.not_advisable || 'Not Advisable'}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {/* @* Restrictions Legend *@ */}
                            <div className="restrictions-legend">
                                <table className="restrictions-legend-table">
                                    <thead>
                                        <tr className="restrictions-first-tr">
                                            <td colSpan={6}>
                                                {translateValue?.planting_legend || 'Planting Legend'}
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>A</td>
                                            <td>
                                                {translateValue?.resLegTooLoSoilTemp ||'ResLegTooLoSoilTemp'}
                                            </td>
                                            <td>P</td>
                                            <td>
                                                {translateValue?.resPastPrecipitation ||'ResPastPrecipitation'}
                                            </td>
                                            <td>p</td>
                                            <td>
                                                {translateValue?.resPrecipitationExpected || 'ResPrecipitationExpected'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>X</td>
                                            <td>{translateValue?.multiple || 'Multiple'}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </IF>

                </div>
            </IF>

            {/* Mixed */}
            <IF show={currentPlantingDataForMixed?.length >= 1 || currentPlantingForFranceDataForMixed?.length >= 1}>
                <div className="planting-all-container" style={{overflow:'auto'}}>
                    <div className="historical-chart-title common-title">
                        {translateValue?.planting_recommendation || 'Planting Recommendation'} {` - ${translateValue?.forecast + ' ' + translateValue?.and + ' ' + translateValue?.historical}`}
                    </div>
                    {/* hourly */}
                    <IF show={currentPlantingDataForMixed?.length >= 1}>
                        <div className="">
                            <div className="forecast-table content-basic">
                                {/* different item mean different time */}
                                {currentPlantingDataForMixed?.map((trueItem, index) => {
                                    return (
                                        <>
                                            <div
                                                // key={`spray-container-${index}-${item?.id}`}
                                                key={cuid.createId()}
                                                className="spray-list-container"
                                            >
                                                <div
                                                    className="spray-item-name"
                                                    style={{ margin: '5px 0px' }}
                                                >
                                                    {trueItem?.cropName}
                                                </div>
                                                <table className="spray-table-container">
                                                    <thead>
                                                        <tr>
                                                            <td className="thead-tr-var basic-first-td">
                                                                {translateValue?.hours_of_the_day ||
                                    'Hours of the day'}
                                                            </td>
                                                            {Array.from({ length: 24 }, (_, i) =>
                                                                i < 10 ? `0${i}` : `${i}`
                                                            ).map((item) => {
                                                                return (
                                                                    <>
                                                                        <td className="thead-tr-day basic-td">
                                                                            {item}
                                                                        </td>
                                                                    </>
                                                                );
                                                            })}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {trueItem?.values?.map(
                                                            (valueItem, valueIndex) => {
                                                                return (
                                                                    <>
                                                                        <tr key={cuid.createId()}>
                                                                            <td className="tdoby-tr-var basic-first-td"
                                                                                style={{
                                                                                    fontWeight: `${trueItem?.date?.[valueIndex] === currentMixedToday ? 800 : 400}`,
                                                                                }}
                                                                            >
                                                                                {`${trueItem?.date?.[valueIndex]}`}
                                                                            </td>
                                                                            {valueItem?.map(
                                                                                (innerItem, innerIndex) => {
                                                                                    return (
                                                                                        <td
                                                                                            key={cuid.createId()}
                                                                                            className="tdoby-tr-day basic-td"
                                                                                            style={{
                                                                                                backgroundColor: `${trueItem?.backColors?.[valueIndex]?.[innerIndex]}`,
                                                                                            }}
                                                                                        >
                                                                                            {innerItem || ''}
                                                                                        </td>
                                                                                    );
                                                                                }
                                                                            )}
                                                                        </tr>
                                                                    </>
                                                                );
                                                            }
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    );
                                })}
                            </div>

                            {/* @* Color Legend *@ */}
                            <div className="new-color-legend" >
                                <table className="color-legend-table">
                                    <thead>
                                        <tr className="color-first-tr">
                                            <td colSpan={6}>
                                                {translateValue?.color_legend || 'Color Legend'}
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div
                                                    className="square"
                                                    style={{ backgroundColor: 'rgb(65, 195, 4)' }}
                                                ></div>
                                            </td>
                                            <td>
                                                <span>{translateValue?.recommended || 'Recommended'}</span>
                                            </td>
                                            <td>
                                                <div
                                                    className="square"
                                                    style={{ backgroundColor: 'rgb(238, 26, 26)' }}
                                                ></div>
                                            </td>
                                            <td>
                                                <span>{translateValue?.not_advisable || 'Not Advisable'}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* @* Restrictions Legend *@ */}
                            <div className="restrictions-legend">
                                <table className="restrictions-legend-table">
                                    <thead>
                                        <tr className="restrictions-first-tr">
                                            <td colSpan={6}>
                                                {translateValue?.planting_legend || 'Planting Legend'}
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>A</td>
                                            <td>
                                                {translateValue?.resLegTooLoSoilTemp || 'ResLegTooLoSoilTemp'}
                                            </td>
                                            <td>T</td>
                                            <td>
                                                {translateValue?.resLegTooLoTemp || 'ResLegTooLoTemp'}
                                            </td>
                                            <td>R</td>
                                            <td>
                                                {translateValue?.resLegPrecipitation || 'ResLegPrecipitation'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>S</td>
                                            <td>{translateValue?.resRainExpected || 'ResRainExpected'}</td>
                                            <td>W</td>
                                            <td>{translateValue?.resLegSoilTooWet || 'ResLegSoilTooWet'}</td>
                                            <td>X</td>
                                            <td>{translateValue?.multiple || 'Multiple'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </IF>

                    {/* daily */}
                    <IF show={currentPlantingForFranceDataForMixed?.length >= 1}>
                        <div>
                            <table
                                // key={`table-${index}-${tableIndex}`}
                                className="daily-table-container"
                            >
                                <thead>
                                    <tr>
                                        <td></td>
                                        {maxMixedDate.map((day, dayIndex) => (
                                            <td
                                                key={`day-${dayIndex}`}
                                                style={{
                                                    width: `${((822 - 130) / (maxMixedDate?.length || 1))}px`,
                                                    padding: '3px 0px',
                                                    fontWeight: `${day === currentMixedToday ? 800 : 400}`,
                                                }}
                                            >
                                                {day}
                                            </td>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        currentPlantingForFranceDataForMixed?.flat()?.map((item, index) => {
                                            return (
                                                <tr
                                                    key={`item-${index}`}
                                                >
                                                    <td
                                                        style={{
                                                            width: '130px',
                                                        }}
                                                    >
                                                        {item?.cropName}
                                                    </td>
                                                    {/* render detail value */}
                                                    {maxMixedDate.map((day, dayIndex) => {
                                                        const valueIndex = item.date?.findIndex((dateItem) => dateItem === day);
                                                        const color = valueIndex !== -1 ? item?.backColors?.[valueIndex] : 'grey';
                                                        const value = valueIndex !== -1 ? item?.values?.[valueIndex] : '';
                                                        return(
                                                            <td
                                                                key={`day-${dayIndex}`}
                                                                style={{
                                                                    width: `${((822 - 130) / (maxMixedDate?.length || 1))}px`,
                                                                    height: '30px',
                                                                    backgroundColor: `${color}`,
                                                                    // color: `${color}`,
                                                                    boxSizing: 'border-box',
                                                                    padding: '3px 0px',
                                                                }}
                                                            >
                                                                {value}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })
                                    }
                                </tbody>
                            </table>

                            {/* @* Color Legend *@ */}
                            <div className="new-color-legend">
                                <table className="color-legend-table">
                                    <thead>
                                        <tr className="color-first-tr">
                                            <td colSpan={6}>
                                                {translateValue?.color_legend || 'Color Legend'}
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div className="square" style={{ backgroundColor: 'rgb(65, 195, 4)' }}></div>
                                            </td>
                                            <td>
                                                <span>{translateValue?.recommended || 'Recommended'}</span>
                                            </td>
                                            <td>
                                                <div className="square" style={{ backgroundColor: 'rgb(225, 122, 0)' }}></div>
                                            </td>
                                            <td>
                                                <span>{translateValue?.limited || 'Limited'}</span>
                                            </td>
                                            <td>
                                                <div className="square" style={{ backgroundColor: 'rgb(238, 26, 26)' }}></div>
                                            </td>
                                            <td>
                                                <span>
                                                    {translateValue?.not_advisable || 'Not Advisable'}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            {/* @* Restrictions Legend *@ */}
                            <div className="restrictions-legend">
                                <table className="restrictions-legend-table">
                                    <thead>
                                        <tr className="restrictions-first-tr">
                                            <td colSpan={6}>
                                                {translateValue?.planting_legend || 'Planting Legend'}
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>A</td>
                                            <td>
                                                {translateValue?.resLegTooLoSoilTemp ||'ResLegTooLoSoilTemp'}
                                            </td>
                                            <td>P</td>
                                            <td>
                                                {translateValue?.resPastPrecipitation ||'ResPastPrecipitation'}
                                            </td>
                                            <td>p</td>
                                            <td>
                                                {translateValue?.resPrecipitationExpected || 'ResPrecipitationExpected'}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>X</td>
                                            <td>{translateValue?.multiple || 'Multiple'}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </IF>
                </div>
            </IF>
        </div>
    );
};

export default TemplatePlanting;
